<template>
  <div class="layout-container">
    <!-- <Sidebar @on-change="sidebarChange"></Sidebar> -->
    <div class="main-container">
      <Header />
      <main class="main">
        <div class="error">
          <!-- <div class="error-msg">{{ error.statusMessage }}</div> -->
          <!-- error.msg 来自: util/common.ts-handleNodeServerError -->
          <div class="error-tip">
            页面错误，请稍后重试!
            <span class="more" @click="isShowMsg = true">更多>></span>
          </div>
          <div class="error-msg" v-if="isShowMsg">{{ errorMessage }}</div>
          <div
            class="button_box row-flex jsb ac"
            style="gap: 50px">
            <!-- <nuxt-link to="/" title="展会网">返回首页</nuxt-link> -->
            <a
              style="cursor: pointer"
              @click="handleHome">
              返回首页
            </a>

            <a
              style="cursor: pointer"
              @click="handleRefresh">
              重试
            </a>
          </div>
        </div>
      </main>
      <Footer2 />
    </div>
  </div>
</template>
<script lang="ts" setup>
  // @ts-ignore
  import { defineProps } from 'vue'
  import { timestampToDateTime } from '~/utils/common'

  const Header = defineAsyncComponent(() => import('~/components/Header/index.vue'))
  const Footer2 = defineAsyncComponent(() => import('~/components/Footer2/index.vue'))

  const router = useRouter()

  const props = defineProps({
    error: {
      type: Object,
      default: () => {}
    }
  })

  //

  console.error('服务器错误-error--35', {
    error: props.error,
    time: timestampToDateTime(Date.now())
  })

  let errorMessage = ref('')
  let isShowMsg = ref(false)
  // 解析错误信息
  try {
    console.log('error.vue-39', props.error)
    if (props.error.hasOwnProperty('message')) {
      let messageRes = JSON.parse(props.error.message)
      errorMessage.value = messageRes.errorMsg
      // console.log('error.vue-40', props.error.message)
      console.log('error.vue-41', messageRes)
    }
  } catch (e) {
    errorMessage.value = props.error.message
  }

  // console.dir(props.error)
  const handleHome = () => {
    // router.push('/')
    location.href = '/'
  }
  const handleRefresh = () => {
    location.reload()
  }
</script>
<style lang="less" scoped>
  .main {
    min-height: 630px;
  }

  .error {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 128px 0;

    &-msg {
      font-size: 32px;
      font-weight: bold;
      margin-bottom: 64px;
    }

    a {
      color: @app-color;
      text-decoration: underline;
      font-size: 28px;
    }
  }
  .error-msg{
    width: 100%;
    overflow: auto;
    text-align: center;
  }
  .error-tip{
    width:100%;
    text-align: center;
    font-size: 32px;
    font-weight: 700;
    margin-bottom:40px;
    .more{
      font-size:24px;
      display: inline-block;
      margin-left: 15px;
      font-weight: 400;
      cursor: pointer;
    }
  }
</style>
